<button mat-button class="headline font-bold m-2" (click)="clacAmountViewExpanded = !clacAmountViewExpanded">Aufmaß {{clacAmountViewExpanded ? '-' : '+'}}</button>
<app-arl-amount-calculation-view *ngIf="clacAmountViewExpanded" [quantityHistoryForm]="quantityHistoryForm"></app-arl-amount-calculation-view>
<br>
<button mat-button class="headline font-bold m-2" (click)="clacViewExpanded = !clacViewExpanded">Kalkulation {{ clacViewExpanded ? '-' : '+' }}</button>
<app-arl-calculation-view
    *ngIf="clacViewExpanded"
    [expanded]="clacViewExpanded"
    [disabled]="disabled"
    [inheritFromChildrenForm]="_inheritFromChildrenForm"
    [FilterMaterialsByCustomerId]="FilterMaterialsByCustomerId"
    [isOrder]="isOrder"
    [isOffer]="isOffer"
    [forceQuantityTypeIdForEmployeeArls]="forceQuantityTypeIdForEmployeeArls"
    [arlHelper]="_arlTableCalculationPositionHelper"
></app-arl-calculation-view>
<!--<app-arl-calculation-view-->
<!--    [ARLCalculationPreChargeByTypes]="ARLCalculationPreChargeByTypes"-->
<!--    [aRLCalculationPreCharge]="aRLCalculationPreCharge"-->
<!--    [ZuschlaegeResourcen]="ZuschlaegeResourcen"-->
<!--    [ZuschlaegeMaterials]="ZuschlaegeMaterials"-->
<!--    [ZuschlaegeDefault]="ZuschlaegeDefault"-->
<!--    [ZuschlaegeEmployee]="ZuschlaegeEmployee"-->
<!--    [ZuschlaegeExternalService]="ZuschlaegeExternalService"-->
<!--    [ZuschlaegeOther]="ZuschlaegeOther"-->
<!--    [ARLSurChargeByTypes]="ARLSurChargeByTypes"-->
<!--    [childrenVisibleForm]="childrenVisibleForm"-->
<!--    [expanded]="clacViewExpanded"-->
<!--    [disabled]="disabled"-->
<!--    [arl]="_arl"-->
<!--    [positionPrefix]="_positionPrefix"-->
<!--    [inheritFromChildrenForm]="_inheritFromChildrenForm"-->
<!--    [FilterMaterialsByCustomerId]="FilterMaterialsByCustomerId"-->
<!--    [isOrder]="isOrder"-->
<!--    [isOffer]="isOffer"-->
<!--    [forceQuantityTypeIdForEmployeeArls]="forceQuantityTypeIdForEmployeeArls"-->
<!--    (calculatedAmount)="calculatedAmount.emit($event)"-->
<!--    [arlHelper]="arlTableCalculationPositionHelper"-->
<!--&gt;</app-arl-calculation-view>-->
<div class="action-row flex gap-2 w-full p-4 gap-2">
    <button app-button Color="cancel" [IsLoading]="ls.IsLoading$ | async" Inverted (click)="onAbortClick()">abbrechen</button>
    <span class="grow"></span>
<!--    <button app-button Color="red" [Disabled]="disabled" [IsLoading]="ls.IsLoading$ | async" (click)="onDeleteClick()">löschen</button>-->
<!--    <span class="spacer"></span>-->
<!--    <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="someFormDirty$ | async" (click)="onDuplicateClick()">duplizieren</button>-->
<!--    <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="!(someFormDirty$ | async) || (someFormInvalid$ | async)" (click)="onSaveClick()">speichern</button>-->
</div>
